export default "__VITE_ASSET__l868dLSU__"